import { useMemo } from 'react';
import { buildDirectoryGraph } from '../utils/graphBuilders';

export default function useFilterGraph({ operators, units, meters }) {
  return useMemo(() => {
    if (!operators?.length) return null;
    return buildDirectoryGraph(operators, units, meters);
  }, [operators, units, meters]);
}
